import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { AiOutlineEye } from "react-icons/ai";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { PropTypes } from "prop-types";
import Ratings from "./Ratings";
import HalfRating from "./ModalRating";
import { useStateContext } from "../contexts/ContextProvider";
import axios from "axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 700,
  minHeight: 370,
  width: "95%",
  backgroundColor: "rgba(255, 255, 255)",
  backdropFilter: "blur(20px)",
  boxShadow: 24,
  borderRadius: "6px",
  padding: 4,
};

export default function TransitionsModal({ product }) {
  const [alteredDetail, setAlteredDetail] = React.useState([]);


  const {  setIsScrolled,
    itemDetail,
    setItemDetail,
    singleCategoryDetails,
    singleCategory,
    user,
    itemRating,
    setItemRating,
    setCartItem,
    cartItem,
    getCartFromLocalStorage
  } = useStateContext();

  React.useEffect(() => {
    setItemDetail("");
    singleItem(product.prod_id);
  
    window.scrollTo(0, 0);
 
  }, [product.prod_id]);

  React.useEffect(() => {
  
    setAlteredDetail(product);
  }, [product]);

  const handleCartItems = (productId) => {
    let cart = JSON.parse(localStorage.getItem("cartitems")) || [];
    let singleCategoryDetail = [];
    singleCategoryDetail.push(alteredDetail);
    console.log(singleCategoryDetail);
    let product = singleCategoryDetail.find(function (product) {
      return product.prod_id === productId;
    });

    if (cart.length === 0) {
      cart.push(product);
    } else {
      let res = cart.find((element) => element.prod_id === productId);
      if (res === undefined) {
        cart.push(product);
      }
    }

    localStorage.setItem("cartitems", JSON.stringify(cart));
    getCartFromLocalStorage();
    window.scrollTo(-20, 0);
  };

   // Function to fetch single item details
   const singleItem = (id) => {
    axios
      .get(`https://matrix-api-h2bb.onrender.com/item/${id}`)
      .then((res) => setItemDetail(res.data[0]));
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const navigate = useNavigate();
  return (
    <div>
      <div onClick={handleOpen} className="w-4">
        <AiOutlineEye size={20} className="text-xl cursor-pointer" />
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box
            sx={style}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              style={{
                width: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={product.image}
                style={{
                  width: "270px",
                  height: "270px",

                  objectFit: "contain",
                }}
                className="imageContain"
                alt=""
              />
            </Box>
            <div
              style={{
                width: "50%",
              }}
            >
              <p
                style={{
                  fontSize: "30px",
                  fontWeight: "bold",
                }}
              >
                ${product.price}
              </p>
              <div>
                <HalfRating value={product.ratings} />
              </div>
              <Typography
                id="transition-modal-description"
                sx={{ mt: 2, mb: 3 }}
              >
                {product.descr}
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <button
                  style={{
                    backgroundColor: "rgb(195, 42, 169)",
                    color: "white",
                    fontSize: 14,
                    borderRadius: "10px",
                    padding: "10px 30px",
                    border: "1px solid rgb(235, 132, 190)",
                    outline: "none",
                    boxShadow:
                      "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                  }}
                  onClick={() => handleCartItems(product.prod_id)}
                >
                  Add to Cart
                </button>
                <button
                  onClick={() =>
                    navigate(
                      `/products/${product.categories_id}/${product.prod_id}`
                    )
                  }
                  style={{
                    backgroundColor: "rgb(195, 42, 169)",
                    color: "white",
                    fontSize: 14,
                    borderRadius: "10px",
                    padding: "10px 30px",
                    border: "1px solid rgb(235, 132, 190)",
                    outline: "none",
                  }}
                >
                  Details
                </button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

TransitionsModal.propTypes = {
  product: PropTypes.any,
};
